import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { ScheduleMenuItem } from 'Manager/Schedule/SchedulerContextMenu/helpers'
import { openModal } from 'store/actions/modals'
import { ACTIONS } from 'Manager/Schedule/SchedulerContextMenu/constants'

export type MultiItemsMobile = { [key: string]: ScheduleMenuItem & { onClick: () => void } }

const useMultiItemsMobile = (events: MData.SchedulerEvent[]): MultiItemsMobile => {
  const dispatch = useDispatch()
  const { t } = useTranslation('legacy')
  const eventIds = events.map(({ id }) => id) as string[]
  return {
    [ACTIONS.EDIT]: {
      text: t('manager.schedule.CONTEXT_MENU.EDIT_SHIFT'),
      order: 1,
      onClick: () => dispatch(openModal('ScheduleMultiEditModal', { ids: eventIds }))
    },
    [ACTIONS.UNASSIGN_EMPLOYEE]: {
      text: t('manager.schedule.CONTEXT_MENU.UNASSIGN_EMPLOYEES'),
      order: 2,
      onClick: () => dispatch(openModal('ScheduleUnassignEmployeeModal', { ids: eventIds }))
    },
    [ACTIONS.PUBLISH]: {
      text: t('manager.schedule.CONTEXT_MENU.PUBLISH'),
      order: 3,
      onClick: () => dispatch(openModal('SchedulePublishModal', { shiftIds: eventIds }))
    },
    [ACTIONS.UNPUBLISH]: {
      text: t('manager.schedule.CONTEXT_MENU.UNPUBLISH'),
      order: 4,
      onClick: () => dispatch(openModal('ScheduleUnpublishModal', { shiftIds: eventIds }))
    },
    [ACTIONS.CANCEL]: {
      text: t('manager.schedule.CONTEXT_MENU.CANCEL'),
      order: 5,
      onClick: () => {
        dispatch(openModal('ScheduleCancelModal', { ids: eventIds }))
      }
    },
    [ACTIONS.RESTORE]: {
      text: t('manager.schedule.CONTEXT_MENU.RESTORE_SELECTED'),
      order: 6,
      onClick: () => {
        dispatch(openModal('ScheduleRestoreModal', { ids: eventIds }))
      }
    },
    [ACTIONS.CREATE_LIST]: {
      text: t('manager.schedule.CONTEXT_MENU.CREATE_LIST'),
      order: 7,
      onClick: () => dispatch(openModal('ContactListCreationModal', { ids: eventIds }))
    }
  } as const
}

export { useMultiItemsMobile }
